import React from "react";

import ButtonPrimary from "../../../../shared/items/contols/buttonPrimary";
import { states } from "../../../../reducers/queriesStates";
import { withDataAnalyseTimeRange } from "../../../../shared/containers/containerDataAnalyseTimeRange";
import { withCurrentDevices } from "../../../../shared/containers/containerCurrentDevice";
import { withDataAnalyse } from "../../../../shared/containers/containerDataAnalyse";

const getIntellegenceData = (props) => {
  const { rangeStartDate, rangeEndDate, rangeStartTime, rangeEndTime, currentDevice, onGetSimpleSignals } = props;

  const startDate = new Date(rangeStartDate);
  const startTime = new Date(rangeStartTime);
  startDate.setHours(startTime.getHours());
  startDate.setMinutes(startTime.getMinutes());

  const endDate = new Date(rangeEndDate);
  const endTime = new Date(rangeEndTime);
  endDate.setHours(endTime.getHours());
  endDate.setMinutes(endTime.getMinutes());
  endDate.setSeconds(59);

  onGetSimpleSignals({ currentDevice, startDate, endDate });
};

const DataAnalyseButtonWrapper = (props) => {
  const { disabled, timerangeIntelligenceState } = props;

  return (
    <ButtonPrimary
      handleClick={getIntellegenceData.bind(this, props)}
      title="Показать"
      disabled={disabled || timerangeIntelligenceState === states.REQUEST ? true : false}
    />
  );
};

export default withDataAnalyse(withCurrentDevices(withDataAnalyseTimeRange(React.memo(DataAnalyseButtonWrapper))));
